import { PageSection, SectionKind } from "@/apps/page/page.interfaces";
import { randomId } from "@/shared/utils/helpers";

export function makeSection(
    initialState: Partial<PageSection>,
    order: number,
    kind: SectionKind = "block"
) {
    const id = randomId();
    const webId = id.toString(24);

    return {
        styleValues: {},
        ...initialState,
        _created: true,
        isHidden: false,
        id,
        webId,
        order,
        kind,
    };
}

/**
 * Reorder sections on insert, or push newSection to the end
 */
export function mutateSections(
    sections: PageSection[],
    newSection: PageSection,
    position?: number
) {
    if (typeof position === "number") {
        sections.splice(newSection.order, 0, newSection);
        sections.forEach((s, index) => {
            s.order = index;
            if (!s._created && !s._deleted) {
                s["_changed"] = true;
            }
        });
    } else {
        sections.push(newSection);
    }
}
